import { render } from "./TipiIncasso.vue?vue&type=template&id=328a7373"
import script from "./TipiIncasso.vue?vue&type=script&lang=js"
export * from "./TipiIncasso.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__